module.exports = __webpack_public_path__ + "static/media/btn_tiger_active.a41d704e.png";